<template>
  <v-footer id="core-footer" height="auto" v-if="$route.name !== 'Maintenance'">
    <v-layout align-start justify-center row wrap>
      <!-- <v-flex xs12 md3>
        <v-layout column wrap>
          <v-card class="flex" flat tile>
            <v-container grid-list-md style="padding-bottom: 0 !important">
              <v-layout
                justify-center
                row
                wrap
                fill-height
                class="text-xs-left text-md-right"
              >
                <v-card-text class="body-1 pb-2"
                  >Let's Create Something Together.</v-card-text
                >
                <v-card-text class="caption pt-0 pb-0">
                  &copy; Copyright {{ new Date().getFullYear() }}
                  EverOwl Technologies.
                </v-card-text>
                <v-card-text class="caption pt-0 pb-0"
                  >All Rights Reserved.</v-card-text
                >
              </v-layout>
            </v-container>
          </v-card>
        </v-layout>
      </v-flex> -->
      <v-flex xs12>
        <!-- <v-layout align-start justify-center column wrap>
          <v-flex xs12>
            <v-card class="flex hidden-sm-and-down" flat tile>
              <v-container grid-list-md>
                <v-layout justify-center row wrap fill-height>
                  <v-card-text class="subheading font-weight-bold font-italic">
                    "None of us, including me, ever do great things. But we can all do small things, with great love, and together we can do something wonderful."
                    <br>– Mother Teresa
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout> -->
        <v-layout>
          <v-flex xs12>
            <v-layout column wrap>
              <v-card flex flat tile>
                <v-container grid-list-md>
                  <v-layout justify-center row wrap fill-height>
                    <v-flex
                      xs12
                      md3
                      class="flex text-xs-left text-md-right pr-3"
                    >
                      <!--                     
                          <v-container
                            grid-list-md
                            style="padding-bottom: 0 !important"
                          >
                            <v-layout
                              justify-center
                              row
                              wrap
                              fill-height
                              class="text-xs-left text-md-right"
                            > -->
                      <v-card-text class="subheading pb-3"
                        >Let's Create Something Together.</v-card-text
                      >
                      <v-card-text class="caption pt-0 pb-0">
                        &copy; Copyright {{ new Date().getFullYear() }}
                        EverOwl Technologies.
                      </v-card-text>
                      <v-card-text class="caption pt-0 pb-0"
                        >All Rights Reserved.</v-card-text
                      >
                      <!-- </v-layout>
                          </v-container>
               -->
                    </v-flex>

                    <v-flex xs12 md3 class="flex">
                      <v-card-text
                        class="subheading pb-0 grey--text hidden-sm-and-down"
                        >Start a conversation</v-card-text
                      >
                      <v-card-text
                        class="subheading space-30 grey--text hidden-md-and-up"
                        >Start a conversation</v-card-text
                      >
                      <v-card-text class="body-2 pb-0"
                        >+6012-444 5347 (Kelf)</v-card-text
                      >
                      <v-card-text class="body-2 pb-1 pt-0"
                        >+6012-340 0437 (Nicholas)</v-card-text
                      >
                      <v-card-text class="body-2 pt-0"
                        >support@everowl-technologies.com</v-card-text
                      >
                    </v-flex>
                    <v-flex xs12 md2 class="flex">
                      <v-card-text
                        class="subheading pb-0 grey--text hidden-sm-and-down"
                        >Located at</v-card-text
                      >
                      <v-card-text
                        class="subheading space-30 grey--text hidden-md-and-up"
                        >Located at</v-card-text
                      >
                      <v-card-text class="body-2 pb-0 black--text"
                        >Kuala Lumpur</v-card-text
                      >
                    </v-flex>
                    <v-flex xs12 md3 class="text-xs-center text-md-left">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn key="mdi-facebook" class="mx-1" icon>
                            <v-icon color="black" size="24px" v-on="on"
                              >mdi-facebook</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Unavailable at the moment :(</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn key="mdi-google" class="mx-1" icon>
                            <v-icon color="black" size="24px" v-on="on"
                              >mdi-google</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Unavailable at the moment :(</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn key="mdi-linkedin" class="mx-1" icon>
                            <v-icon color="black" size="24px" v-on="on"
                              >mdi-linkedin</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Unavailable at the moment :(</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="
                              redirectTo(
                                'https://www.instagram.com/everowltech'
                              )
                            "
                            key="mdi-instagram"
                            class="mx-1"
                            icon
                          >
                            <v-icon color="black" size="24px" v-on="on"
                              >mdi-instagram</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Go to our Instagram!</span>
                      </v-tooltip>
                      <!-- <v-card-text class="caption pt-4 pb-2 grey--text">TERMS & CONDITIONS</v-card-text>
                    <v-card-text class="caption pt-0 grey--text">PRIVACY POLICY</v-card-text> -->
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: ["mdi-facebook", "mdi-google-plus", "mdi-linkedin", "mdi-instagram"],
  }),

  methods: {
    redirectTo(location) {
      window.open(location);
    },
  },
};
</script>

<style>
#core-footer {
  background-color: #ffffff;
  color: #000 !important;
}
</style>
